<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <h2>{{translate?.general.buttons.clone.singular}}&nbsp;{{translate?.jobOrder.label.singular}}&nbsp;{{translate?.setup.modules.picklist.type.label.singular}}</h2>
        <button class="icon-btn" aria-label="Close" [pTooltip]="translate?.general.buttons.close.singular" (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__subheader">
        <h3>{{translate?.setup.modules.types.messages.adjustSettings}} {{translate?.general.buttons.new.singular | lowercase}} {{translate?.jobOrder.label.singular}}&nbsp;{{translate?.setup.modules.picklist.type.label.singular}}</h3>
    </div>
    

    <div class="flx-modal__body mp-body">

        <div class="mp-inline-row-box mp-row">
            <div class="mp-note-label">{{translate?.setup.modules.types.messages.cloningFrom}}:</div>
            <div class="mp-note-option me-1">{{data?.name}}</div>
        </div>
       <section class="mp-subpanel mp-row">
            <!-- Plan Details -->
            <div class="mp-sub-body">
                <!-- Plan Name -->
                <div class="mp-plan-title-row">
                    <div>
                        <input class="mp-plan-name" type="text" [(ngModel)]="joTypeName" (input)="onNameChange($event)"
                            [ngClass]="{'invalid-input': hasError || hasLengthError}" placeholder="Type Name" 
                            aria-label="Plan name" 
                        />
                        <p class="mp-hint mt-4px mb-0">{{translate?.setup.modules.types.messages.chooseName}}</p>
                        <div class="p-error text-10" *ngIf="hasError">
                            <span id="label_AssetLocStreetReqField">{{ data?.translateData?.general.validationFE.requiredField }}</span>
                        </div>
                        <div class="p-error text-10" *ngIf="hasLengthError">
                            <span id="label_AssetLocStreetReqField">{{translate?.setup.modules.picklist.type.validationFE.maximumCharsExceed}}.</span>
                        </div>
                        
                    </div>
                </div>
            </div>
        </section>
    </div>

    <div class="flx-modal__footer">
        <button type="button" class="custella-btn-white" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
        <p-button icon="fa-regular fa-check" [label]="translate?.general.buttons.confirm.singular" (onClick)="confirm()" styleClass="h-32"></p-button>
    </div>
</div>